"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isRequiredForA11y(validator) {
    return function validate(props, propName, componentName, location, propFullName) {
        var args = [];
        for (var _i = 5; _i < arguments.length; _i++) {
            args[_i - 5] = arguments[_i];
        }
        var componentNameSafe = componentName || '<<anonymous>>';
        var propFullNameSafe = propFullName || propName;
        if (props[propName] == null) {
            return new Error("The " + location + " `" + propFullNameSafe + "` is required to make " +
                ("`" + componentNameSafe + "` accessible for users of assistive ") +
                'technologies such as screen readers.');
        }
        return validator.apply(void 0, [props, propName, componentName, location, propFullName].concat(args));
    };
}
exports.isRequiredForA11y = isRequiredForA11y;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/react-prop-types/is-required-for-a11y.js
// module id = 192
// module chunks = 0 1 2 3 4 5 6